module.exports = __webpack_public_path__ + "img/support-2.65090072.png";